import { Button } from '@/components/common/Button';
import { Section } from '@/components/common/Section';
import {
  Card,
  CardContent,
  CardHeader,
  CardsContainer,
} from '@/components/dashboard/DashboardCard';
import { routes } from '@/routes/routes';
import { WarningAltFilled } from '@carbon/icons-react';
import { Link, useParams } from '@tanstack/react-router';

export const MyCartCheckoutFailPage = () => {
  const { cartId } = useParams({
    from: '/_dashboard-layout/dashboard/my-carts/$cartId/checkout-fail',
  });

  return (
    <Section>
      <CardsContainer className="-mx-4 lg:mx-0">
        <Card>
          <CardHeader>
            <div className="mx-auto flex flex-col items-center gap-6 py-8">
              <div className="bg-destructive/10 flex size-20 items-center justify-center rounded-full">
                <WarningAltFilled className="text-destructive size-12" />
              </div>
              <h2 className="text-2xl font-semibold">Payment Failed</h2>
              <p className="text-muted-foreground text-center">
                Payment was cancelled or failed. Please try again.
              </p>
            </div>
          </CardHeader>

          <CardContent className="flex flex-col gap-3 pb-8 sm:flex-row sm:justify-center">
            <Button asChild variant="primary">
              <Link
                to={routes.dashboard.myCarts.cart.checkout}
                params={{ cartId }}
              >
                Try Again
              </Link>
            </Button>
            <Button asChild variant="outlinePrimary">
              <Link to={routes.help.contactUs}>Contact Support</Link>
            </Button>
          </CardContent>
        </Card>
      </CardsContainer>
    </Section>
  );
};
